import { render, staticRenderFns } from "./AsignacionCurso.vue?vue&type=template&id=6400cd32"
import script from "./AsignacionCurso.vue?vue&type=script&lang=js"
export * from "./AsignacionCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports